<template>
    <div class='charts_group'>

        <div class='realTime_title'>今日实时数据</div>
        <div class='realTime_statistics'>
          <div class='realTime1'>
            <span>安装总数</span>
             <div id="chartid1" class="charclass" />

          </div>

          <div class='realTime2'>
            <span style="color: #20ff4d">今日在线</span>
              <div id="chartid2" class="charclass" />
          </div>

          <div class='realTime3'>
            <span>今日报警</span>
              <div id="chartid3" class="charclass" />
          </div>
        </div>

    </div>

  
</template>

<script>
import echarts from 'echarts'

export default {
  props: {
    linedata: {
      type: Object,
       default() {
        return {}
      }
    },
    id: {
      type: String,
      default: 'chart'
    }
  },
  data() {
    return {
      chart: null,
      chart1: null,
      chart2: null,
    }
  },
  watch: {
       linedata: {
         handler: function(newVal) {
         if (newVal) {
          this.initChart()
         }
       }
    }
 },
  mounted() {
  },
  beforeDestroy() {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
   
    initChart() {

     this.chart = echarts.init(document.getElementById('chartid1'))
      this.chart1 = echarts.init(document.getElementById('chartid2'))
      this.chart2 = echarts.init(document.getElementById('chartid3'))
      
      var charjson1 = this.linedata.opetions[0]
      var charjson2 = this.linedata.opetions[1]
      var charjson3 = this.linedata.opetions[2]

      var chart_params_data = this.linedata.data
          var reg = new RegExp('number', 'g')
          const newMsg = charjson1.replace(reg, chart_params_data.number)
          charjson1 = newMsg
          var reg1=null
          var newMsg1=null
          if(charjson2.indexOf('off_number') !=-1){
            reg1= new RegExp('off_number', 'g')
            newMsg1 =charjson2.replace(reg1, chart_params_data.off_number)

          }else
          {
            reg1= new RegExp('on_number', 'g')
            newMsg1 =charjson2.replace(reg1, chart_params_data.on_number)
          }
          charjson2 = newMsg1
          var reg2 = new RegExp('alarm_number', 'g')
          const newMsg2 =charjson3.replace(reg2, chart_params_data.alarm_number)
          charjson3 = newMsg2

      var options = JSON.parse(charjson1)
      this.chart.setOption(options)
      var options1 = JSON.parse(charjson2)
      this.chart1.setOption(options1)
      var options2 = JSON.parse(charjson3)
      this.chart2.setOption(options2)


    }
  }
}
</script>

<style lang='less' scoped>
    .charts_group {
        width: 100%;
        height: 100%;
        // position: relative;

        .realTime_title {

            font-size: 18px;
            left: 20px;
             position: relative;
            width: 100%;
            height: 3%;
            z-index: 2;

        }

        .realTime_statistics {
            display: flex;
            text-align: center;
            // position: relative;
            font-size: 16px;
            width: 100%;
            height: 100%;
            // background-color: greenyellow;
            span {
                cursor: pointer;
            }

            .realTime1 {
                flex: 1;
                color: #00e4ff;
                margin-top: 10%;
                cursor: pointer;

            }

            .realTime2 {
                flex: 1;
                color: #848586;
                cursor: pointer;
                margin-top: 10%;

            }

            .realTime3 {
                flex: 1;
                color: #f90002;
                cursor: pointer;
                 margin-top: 10%;

                
            }
            .charclass{
                position: relative;
                top: 0%;
                width: 100%;
                height: 90%;
                // background-color: red;
                // margin-left: 100%;

            }
             .charclass1{
                position: relative;
                top: 0%;
                width: 100%;
                height: 90%;
                background-color: rgb(47, 26, 165);
                // margin-left: 100%;

            }
             .charclass2{
                position: relative;
                top: 0%;
                width: 100%;
                height: 90%;
                background-color: rgb(206, 194, 36);
                // margin-left: 100%;

            }
        }

    }
</style>


// WEBPACK FOOTER //
// src/components/chart/chart_statistics.vue